<template>
    <button
        class="flex items-center justify-center h-10 py-1.5 px-3 min-w-20 rounded-lg | transition duration-200 | focus:outline-none"
        :class="[className, { 'focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-blue-500': !isDisabled }]"
        :disabled="isDisabled"
        type="button"
        @click="$emit('click')"
        v-text="label"
    />
</template>

<script>
    export default {
        name: 'ActivixPill',

        props: {
            label: {
                type: String,
                required: true,
            },
            isActive: {
                type: Boolean,
                default: false,
            },
            isDisabled: {
                type: Boolean,
                default: false,
            },
        },

        computed: {
            className() {
                if (this.isDisabled) {
                    return 'cursor-not-allowed text-gray-500';
                }

                if (this.isActive) {
                    return 'bg-gray-250 text-gray-800';
                }

                return 'text-gray-700 hover:bg-gray-150 hover:text-gray-750';
            },
        },
    };
</script>
